export default __webpack_public_path__ + "static/media/truck-time.4706649e.svg";